export default __webpack_public_path__ + "static/media/dragMenuIcon.892bbbcd.svg";